export const CTA_TYPES = [
  {
    cta_type_id: 1,
    cta_name: 'Install',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 2,
    cta_name: 'Download',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 4,
    cta_name: 'Shop',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 5,
    cta_name: 'Sign up',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 6,
    cta_name: 'Watch',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 7,
    cta_name: 'Join',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 8,
    cta_name: 'Start',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 9,
    cta_name: 'Subscribe',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 10,
    cta_name: 'Add',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 11,
    cta_name: 'Search',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 12,
    cta_name: 'Share',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 13,
    cta_name: 'Get',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 14,
    cta_name: 'Book',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 15,
    cta_name: 'Play',
    cta_category_id: 1,
    cta_category_name: 'CTA for UA',
  },
  {
    cta_type_id: 17,
    cta_name: 'Use',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 18,
    cta_name: 'Play',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 19,
    cta_name: 'Reserve',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 20,
    cta_name: 'Buy',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 21,
    cta_name: 'View',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 22,
    cta_name: 'Log in',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 23,
    cta_name: 'Listen',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 24,
    cta_name: 'Read',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 25,
    cta_name: 'Watch',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 26,
    cta_name: 'See more',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 27,
    cta_name: 'Find',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 28,
    cta_name: 'Book',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 31,
    cta_name: 'Chat',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 32,
    cta_name: 'Read',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 33,
    cta_name: 'Park',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 34,
    cta_name: 'Open',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 35,
    cta_name: 'Exercise',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
  {
    cta_type_id: 36,
    cta_name: 'Optimize',
    cta_category_id: 2,
    cta_category_name: 'CTA for RE',
  },
];

export const MEDIATYPES = {
  IMAGE: 'image',
  IMAGE_LANDSCAPE: 'image_landscape',
  ICON: 'icon',
  VIDEO: 'video',
  VIDEO_LANDSCAPE_URL: 'video_landscape',
  VIDEO_PORTRAIT_URL: 'video_portrait',
};

export const MODELSTATES = {
  UPLOADING_IMAGE: 'uploading',
  AFTERCROP: 'AFTERCROP',
  EMPTY: 'empty',
  IMAGESELECTED: 'image selected',
  LANDSCAPEVIDEOSELECTED: 'landscapevideo',
  VIDEOSELECTED: 'videoselected',
  CROPPING: 'cropping',
};

export const BUTTON_LABELS = {
  USE_CROPPED: 'Use Cropped',
  USEDATCREATIVE: 'Use this Creative',
  UPLOADVIDEO: 'UPLOAD VIDEO',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  BROWSE_IMAGES: 'Browse Images',
  BROWSE_VIDEOS: 'Browse Videos',
};
